import { Dispatcher, getProxyObject, IDispatcher } from "@fanfanlo";
import { type IVisit } from '../../remote/visit/appStart';

export interface IAppModel {
  visitInfo?: IVisit
  dispatcher:IDispatcher
}

// export class AppModelImpl extends Dispatcher implements IAppModel {
//   constructor() {

//     super();
//   }
//   visitInfo?: IVisit
// }
export const appModel:IAppModel = {
  visitInfo:undefined,
  dispatcher:new Dispatcher()
}
export const appProxyModelObject = getProxyObject(appModel)
export const appProxyModel = appProxyModelObject.proxy


